{
  "clear": "Löschen",
  "invalid": "(ungültig)",
  "loading": "Wird geladen...",
  "noResults": "Keine Ergebnisse"
}
